import React, { useState, useCallback } from "react";
import { CarOutlined } from "@ant-design/icons";
import { Modal, Button, Descriptions, Divider } from "antd";
import { connect } from "dva";
import { Link } from "umi";

const ViewVehicles = ({ configPerm, vehicles = [] }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = useCallback(() => {
    setModalVisible(true);
  }, []);

  const handleCancel = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <>
      <Button type="primary" icon={<CarOutlined />} onClick={showModal} disabled={!vehicles?.length}>
        {vehicles?.length ? `View: ${vehicles?.length} veh.` : "No Vehicles"}
      </Button>
      <Modal
        title={`Vehicles (Total: ${vehicles?.length})`}
        open={modalVisible}
        onCancel={handleCancel}
        bodyStyle={{ maxHeight: 400, overflow: "auto" }}
        footer={null}
      >
        {vehicles.map((vehicle, index) => {
          const { id } = vehicle;
          const { make, model, vin, year } = vehicle;

          return (
            <div key={id}>
              <div>
                <span>VIN:</span>
                &nbsp;
                {configPerm["CoreService.AdminShipments.Vehicles"] || configPerm["CoreService.Shipments.Vehicles"] ? (
                  <Link to={`/vehicles/view?id=${id}`}>
                    <span>{vin}</span>
                  </Link>
                ) : (
                  <span>{vin}</span>
                )}
              </div>
              <Descriptions column={3} layout="vertical" size="small" bordered>
                <Descriptions.Item label="Make">{make}</Descriptions.Item>
                <Descriptions.Item label="Model">{model}</Descriptions.Item>
                <Descriptions.Item label="Year">{year}</Descriptions.Item>
              </Descriptions>
              {vehicles?.length > 1 && index !== (vehicles?.length ?? 0) - 1 && <Divider />}
            </div>
          );
        })}
      </Modal>
    </>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(ViewVehicles);
